import MFeatureEnableSwitch from './MFeatureEnableSwitch.vue';

export { MFeatureEnableSwitch };
export default MFeatureEnableSwitch;
